export const seeds = {
  wasteTypes : [
    'ABS',
    'Acide chlorhydrique',
    'Acide fluorhydrique',
    'Acide nitrique et Acide nitreux',
    'Acide phosphorique et Acide phosphoreux',
    'Acide sulfurique et Acide sulfureux',
    'Acides divers Acier inoxydable',
    'Aérosols',
    'Aluminium',
    'Argile',
    'Batteries Lithium',
    'Batteries Ni-Cd',
    'Batteries Ni-Mh',
    'Batteries Plomb',
    'Béton',
    'Béton ferraillé',
    'Biodéchets',
    'Bois non-traité',
    'Bois traité',
    'Boues',
    'Bouteilles de gaz',
    'Briques',
    'Briques de plâtre',
    'Bronze',
    'Cables électriques',
    'Carton',
    'Catalyseurs',
    'Cloison bois',
    'Cloison plâtre',
    'Combustible',
    'Couveture de toit',
    'Cuivre',
    'DASRI',
    'Déchets amiantés',
    'Déchets d\'Equipements Electriques et Electroniques (DEEE) divers',
    'Déchets Diffus Spécifiques (DDS)',
    'Déchets Diffus Spécifiques (DDS) en mélange',
    'Déchets Industriels Banals (DIB) en mélange',
    'Déchets Industriels Dangereux',
    'Déchets inertes en mélange (béton, briques, tuiles et céramiques)',
    'Déchets verts',
    'DEEE dispositifs médicaux',
    'DEEE Informatiques',
    'DEEE Téléphonie',
    'DEEE, appareils de froid',
    'DTQD ou DDQD',
    'Emballages de peinture, colle, résine ou vernis',
    'Emballages en plastiques',
    'Emballages en verre',
    'Etain',
    'Extincteurs',
    'Fenêtres et fermetures en aluminium',
    'Fenêtres et fermetures en bois',
    'Fenêtres et fermetures en PVC',
    'Films plastiques',
    'Films plastiques agricoles usagés',
    'Filtres à huile',
    'Fonte',
    'Fûts métal',
    'Fûts plastiques',
    'Goudron',
    'Graisses',
    'HFC',
    'Huiles alimentaires',
    'Huiles non-alimentaires',
    'Hydrocarbure',
    'IBC-GRV',
    'Isolant minéral',
    'Laiton',
    'Lampes',
    'Médicaments',
    'Mercure',
    'Métaux en mélange',
    'Métaux ferreux',
    'Métaux lourds',
    'Métaux non-ferreux en mélange',
    'Mobilier',
    'Moquette',
    'Palettes',
    'Papier',
    'PCB – PCT',
    'PEHD',
    'Peinture, verni, encre ou colle',
    'Pesticides',
    'PET',
    'Piles et accumulateurs mélangés',
    'Plastiques en mélange',
    'Plâtre et complexe isolant',
    'Plâtre propre',
    'Plomb',
    'Pneumatiques',
    'Polyéthylène',
    'Polypropylène',
    'Polystyrène',
    'Polystyrène expansé',
    'Polyuréthane',
    'Produits basiques divers',
    'Produits phytosanitaires',
    'PVC',
    'Sable',
    'Solvants',
    'Textile',
    'Textiles souillés',
    'Toner d\'impression',
    'Tuiles et céramiques',
    'Véhicules hors d\'usage (VHU)',
    'Verre plat',
    'Zinc'
],
haulers : [
  {
    '_id': '5a6750d736e5449962b840cb',
    'name': 'KIDGREASE',
    'postcode': 79725,
    'phone': '+33 (937) 572-3983',
    'address': '310 Boerum Place',
    'lat': 49.7297,
    'lng': 2.5223,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Biodéchets',
      'Papier',
      'Carton'
    ],
    'email': 'shaunadean@kidgrease.com'
  },
  {
    '_id': '5a6750d7a3bb462edc5de4d4',
    'name': 'COSMOSIS',
    'postcode': 30919,
    'phone': '+33 (845) 599-2911',
    'address': '374 Agate Court',
    'lat': 48.0249,
    'lng': 0.288,
    'services': {
      'collect': false,
      'treatment': true
    },
    'wastes': [
      'Carton',
      'Carton',
      'Papier'
    ],
    'email': 'shaunadean@cosmosis.com'
  },
  {
    '_id': '5a6750d724a2d09a8c536391',
    'name': 'ELECTONIC',
    'postcode': 76180,
    'phone': '+33 (806) 482-2369',
    'address': '456 Clinton Avenue',
    'lat': 49.5448,
    'lng': 3.4634,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Papier',
      'Papier',
      'Carton'
    ],
    'email': 'shaunadean@electonic.com'
  },
  {
    '_id': '5a6750d72bb694b8168ba7fb',
    'name': 'KONNECT',
    'postcode': 83128,
    'phone': '+33 (812) 440-3767',
    'address': '457 Bedell Lane',
    'lat': 46.3282,
    'lng': 3.8063,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Papier',
      'Biodéchets',
      'Carton'
    ],
    'email': 'shaunadean@konnect.com'
  },
  {
    '_id': '5a6750d74923b5ac0db1f562',
    'name': 'EXTRAGENE',
    'postcode': 86256,
    'phone': '+33 (804) 524-3109',
    'address': '300 Lester Court',
    'lat': 45.2285,
    'lng': -0.6478,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Papier',
      'Papier'
    ],
    'email': 'shaunadean@extragene.com'
  },
  {
    '_id': '5a6750d740f66431e50a619a',
    'name': 'BIZMATIC',
    'postcode': 42144,
    'phone': '+33 (837) 494-2824',
    'address': '247 Rost Place',
    'lat': 46.5752,
    'lng': 2.804,
    'services': {
      'collect': false,
      'treatment': true
    },
    'wastes': [
      'Papier',
      'Papier',
      'Papier'
    ],
    'email': 'shaunadean@bizmatic.com'
  },
  {
    '_id': '5a6750d71295f679253380d7',
    'name': 'FIBEROX',
    'postcode': 57807,
    'phone': '+33 (817) 508-3273',
    'address': '957 Empire Boulevard',
    'lat': 49.6014,
    'lng': 3.4732,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Papier',
      'Carton',
      'Papier'
    ],
    'email': 'shaunadean@fiberox.com'
  },
  {
    '_id': '5a6750d75341248e206fa68f',
    'name': 'SONGBIRD',
    'postcode': 78264,
    'phone': '+33 (826) 567-3182',
    'address': '822 Abbey Court',
    'lat': 46.3067,
    'lng': -1.2522,
    'services': {
      'collect': false,
      'treatment': true
    },
    'wastes': [
      'Papier',
      'Biodéchets',
      'Carton'
    ],
    'email': 'shaunadean@songbird.com'
  },
  {
    '_id': '5a6750d746b3df141f1f0831',
    'name': 'VURBO',
    'postcode': 14195,
    'phone': '+33 (916) 464-3802',
    'address': '968 Vandervoort Avenue',
    'lat': 47.3391,
    'lng': -1.1379,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Carton',
      'Biodéchets'
    ],
    'email': 'shaunadean@vurbo.com'
  },
  {
    '_id': '5a6750d778e2f6ea701450b4',
    'name': 'INEAR',
    'postcode': 83791,
    'phone': '+33 (987) 576-3010',
    'address': '180 Seba Avenue',
    'lat': 45.3982,
    'lng': 0.3841,
    'services': {
      'collect': false,
      'treatment': true
    },
    'wastes': [
      'Papier',
      'Biodéchets',
      'Biodéchets'
    ],
    'email': 'shaunadean@inear.com'
  },
  {
    '_id': '5a6750d70c7df1a362f9fbed',
    'name': 'BALUBA',
    'postcode': 73625,
    'phone': '+33 (951) 542-3438',
    'address': '484 Ide Court',
    'lat': 49.6115,
    'lng': 1.281,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Biodéchets',
      'Biodéchets'
    ],
    'email': 'shaunadean@baluba.com'
  },
  {
    '_id': '5a6750d79013b3e5505093a5',
    'name': 'ENVIRE',
    'postcode': 42045,
    'phone': '+33 (839) 571-2180',
    'address': '307 Ridgewood Avenue',
    'lat': 46.899,
    'lng': -0.7612,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Papier',
      'Carton',
      'Carton'
    ],
    'email': 'shaunadean@envire.com'
  },
  {
    '_id': '5a6750d795a82b4ac20b0222',
    'name': 'ZAPHIRE',
    'postcode': 83128,
    'phone': '+33 (820) 492-3828',
    'address': '770 Victor Road',
    'lat': 46.9864,
    'lng': -0.8457,
    'services': {
      'collect': false,
      'treatment': true
    },
    'wastes': [
      'Carton',
      'Papier',
      'Biodéchets'
    ],
    'email': 'shaunadean@zaphire.com'
  },
  {
    '_id': '5a6750d7f0b976625ed91257',
    'name': 'RECRISYS',
    'postcode': 47345,
    'phone': '+33 (839) 472-3013',
    'address': '962 Broadway ',
    'lat': 46.0548,
    'lng': 0.302,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Biodéchets',
      'Carton',
      'Carton'
    ],
    'email': 'shaunadean@recrisys.com'
  },
  {
    '_id': '5a6750d753d1137af69d36fa',
    'name': 'TALENDULA',
    'postcode': 30737,
    'phone': '+33 (905) 514-3318',
    'address': '608 Ford Street',
    'lat': 48.8591,
    'lng': 1.0348,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Papier',
      'Carton'
    ],
    'email': 'shaunadean@talendula.com'
  },
  {
    '_id': '5a6750d77b2f89dcff9262bb',
    'name': 'PERKLE',
    'postcode': 85686,
    'phone': '+33 (821) 463-2103',
    'address': '931 Oliver Street',
    'lat': 47.7898,
    'lng': 3.199,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Carton',
      'Papier',
      'Carton'
    ],
    'email': 'shaunadean@perkle.com'
  },
  {
    '_id': '5a6750d7f9477dd4b1ee9a67',
    'name': 'BLUEGRAIN',
    'postcode': 35850,
    'phone': '+33 (868) 437-3514',
    'address': '991 Flatbush Avenue',
    'lat': 49.9941,
    'lng': 0.0109,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Biodéchets',
      'Carton'
    ],
    'email': 'shaunadean@bluegrain.com'
  },
  {
    '_id': '5a6750d784a21bd8588c7ccc',
    'name': 'BUZZOPIA',
    'postcode': 24390,
    'phone': '+33 (831) 537-2506',
    'address': '352 Stillwell Place',
    'lat': 45.084,
    'lng': 2.6476,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Carton',
      'Biodéchets',
      'Papier'
    ],
    'email': 'shaunadean@buzzopia.com'
  },
  {
    '_id': '5a6750d719e678114b4d0344',
    'name': 'UNISURE',
    'postcode': 21443,
    'phone': '+33 (876) 486-2058',
    'address': '665 Decatur Street',
    'lat': 47.9083,
    'lng': -0.7079,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Carton',
      'Carton'
    ],
    'email': 'shaunadean@unisure.com'
  },
  {
    '_id': '5a6750d79371716254bf62da',
    'name': 'EMERGENT',
    'postcode': 78869,
    'phone': '+33 (975) 581-2243',
    'address': '974 Grove Street',
    'lat': 47.7576,
    'lng': 1.3979,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Biodéchets',
      'Carton',
      'Biodéchets'
    ],
    'email': 'shaunadean@emergent.com'
  },
  {
    '_id': '5a6750d7b39c69f3627b36d3',
    'name': 'ZEPITOPE',
    'postcode': 46202,
    'phone': '+33 (953) 545-3352',
    'address': '310 Brevoort Place',
    'lat': 45.701,
    'lng': 0.8993,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Biodéchets',
      'Carton'
    ],
    'email': 'shaunadean@zepitope.com'
  },
  {
    '_id': '5a6750d7f3cc64c99e67cf72',
    'name': 'IMMUNICS',
    'postcode': 81102,
    'phone': '+33 (960) 580-3795',
    'address': '738 Vernon Avenue',
    'lat': 49.7833,
    'lng': -0.9481,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Biodéchets',
      'Carton',
      'Carton'
    ],
    'email': 'shaunadean@immunics.com'
  },
  {
    '_id': '5a6750d79b994e15a240a860',
    'name': 'BIOLIVE',
    'postcode': 83455,
    'phone': '+33 (958) 543-3509',
    'address': '101 Hyman Court',
    'lat': 46.6637,
    'lng': 3.9918,
    'services': {
      'collect': false,
      'treatment': true
    },
    'wastes': [
      'Papier',
      'Carton',
      'Carton'
    ],
    'email': 'shaunadean@biolive.com'
  },
  {
    '_id': '5a6750d74a2090149db55a87',
    'name': 'PLEXIA',
    'postcode': 21096,
    'phone': '+33 (839) 451-3758',
    'address': '462 Amity Street',
    'lat': 49.9467,
    'lng': -0.6455,
    'services': {
      'collect': false,
      'treatment': true
    },
    'wastes': [
      'Carton',
      'Carton',
      'Biodéchets'
    ],
    'email': 'shaunadean@plexia.com'
  },
  {
    '_id': '5a6750d79d1e6a09cd0fa1b6',
    'name': 'TWIGGERY',
    'postcode': 53255,
    'phone': '+33 (887) 426-3571',
    'address': '978 Battery Avenue',
    'lat': 45.7929,
    'lng': 3.8888,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Biodéchets',
      'Carton',
      'Biodéchets'
    ],
    'email': 'shaunadean@twiggery.com'
  },
  {
    '_id': '5a6750d7ec3c9925bdd26d7c',
    'name': 'ORBIXTAR',
    'postcode': 19921,
    'phone': '+33 (848) 585-2195',
    'address': '785 Llama Court',
    'lat': 49.5822,
    'lng': -0.358,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Papier',
      'Papier'
    ],
    'email': 'shaunadean@orbixtar.com'
  },
  {
    '_id': '5a6750d7d084550e64f9929f',
    'name': 'QUORDATE',
    'postcode': 20614,
    'phone': '+33 (958) 482-3288',
    'address': '865 Tapscott Avenue',
    'lat': 48.1567,
    'lng': 3.8492,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Carton',
      'Biodéchets'
    ],
    'email': 'shaunadean@quordate.com'
  },
  {
    '_id': '5a6750d79f4716f556b1b137',
    'name': 'MEDIFAX',
    'postcode': 19941,
    'phone': '+33 (974) 452-2810',
    'address': '573 Dorchester Road',
    'lat': 45.8558,
    'lng': -0.8074,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Papier',
      'Carton',
      'Carton'
    ],
    'email': 'shaunadean@medifax.com'
  },
  {
    '_id': '5a6750d79868163429e32fbf',
    'name': 'BLUPLANET',
    'postcode': 80917,
    'phone': '+33 (864) 422-3938',
    'address': '708 Gerald Court',
    'lat': 47.6948,
    'lng': 1.5821,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Papier',
      'Papier',
      'Carton'
    ],
    'email': 'shaunadean@bluplanet.com'
  },
  {
    '_id': '5a6750d731dc4baf156f9b09',
    'name': 'INSURITY',
    'postcode': 42221,
    'phone': '+33 (822) 534-2133',
    'address': '751 Just Court',
    'lat': 49.7455,
    'lng': 3.4429,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Papier',
      'Biodéchets',
      'Biodéchets'
    ],
    'email': 'shaunadean@insurity.com'
  },
  {
    '_id': '5a6750d70292793ef595e7ef',
    'name': 'NEUROCELL',
    'postcode': 19709,
    'phone': '+33 (871) 552-2743',
    'address': '610 Vine Street',
    'lat': 46.5216,
    'lng': -1.8618,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Papier',
      'Papier',
      'Biodéchets'
    ],
    'email': 'shaunadean@neurocell.com'
  },
  {
    '_id': '5a6750d7b046f619edc23a5e',
    'name': 'PLUTORQUE',
    'postcode': 71416,
    'phone': '+33 (887) 516-2199',
    'address': '468 Bayview Avenue',
    'lat': 46.7432,
    'lng': 2.2143,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Biodéchets',
      'Papier',
      'Carton'
    ],
    'email': 'shaunadean@plutorque.com'
  },
  {
    '_id': '5a6750d7b1a022cb1a596eb5',
    'name': 'CODACT',
    'postcode': 38849,
    'phone': '+33 (972) 510-3751',
    'address': '629 Fuller Place',
    'lat': 49.3412,
    'lng': -0.063,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Papier',
      'Carton',
      'Papier'
    ],
    'email': 'shaunadean@codact.com'
  },
  {
    '_id': '5a6750d7bf44655ff3f5dd99',
    'name': 'MARQET',
    'postcode': 21833,
    'phone': '+33 (820) 544-2768',
    'address': '805 Belvidere Street',
    'lat': 46.5428,
    'lng': 0.8456,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Biodéchets',
      'Papier',
      'Papier'
    ],
    'email': 'shaunadean@marqet.com'
  },
  {
    '_id': '5a6750d733e191dab5264d44',
    'name': 'YOGASM',
    'postcode': 44048,
    'phone': '+33 (838) 523-2880',
    'address': '347 Pitkin Avenue',
    'lat': 48.9658,
    'lng': 1.174,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Papier',
      'Papier'
    ],
    'email': 'shaunadean@yogasm.com'
  },
  {
    '_id': '5a6750d741e9910ea58c4b03',
    'name': 'MEDALERT',
    'postcode': 63380,
    'phone': '+33 (817) 411-2018',
    'address': '613 Preston Court',
    'lat': 47.0721,
    'lng': 3.4372,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Biodéchets',
      'Biodéchets'
    ],
    'email': 'shaunadean@medalert.com'
  },
  {
    '_id': '5a6750d79cfe1cc094fce50b',
    'name': 'NIMON',
    'postcode': 37704,
    'phone': '+33 (984) 524-2155',
    'address': '999 Rock Street',
    'lat': 47.6857,
    'lng': 2.477,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Papier',
      'Papier',
      'Biodéchets'
    ],
    'email': 'shaunadean@nimon.com'
  },
  {
    '_id': '5a6750d7364da4fc3fd4b37c',
    'name': 'EZENTIA',
    'postcode': 36997,
    'phone': '+33 (804) 510-3091',
    'address': '681 Woodrow Court',
    'lat': 49.3792,
    'lng': 1.2734,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Papier',
      'Papier',
      'Carton'
    ],
    'email': 'shaunadean@ezentia.com'
  },
  {
    '_id': '5a6750d7878dcdf2875290e6',
    'name': 'REALYSIS',
    'postcode': 66553,
    'phone': '+33 (934) 439-2856',
    'address': '346 Hope Street',
    'lat': 49.5933,
    'lng': 0.5445,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Papier',
      'Biodéchets',
      'Biodéchets'
    ],
    'email': 'shaunadean@realysis.com'
  },
  {
    '_id': '5a6750d7261f533cad81dc2a',
    'name': 'PORTICA',
    'postcode': 20143,
    'phone': '+33 (807) 523-2261',
    'address': '531 Vandervoort Place',
    'lat': 45.8013,
    'lng': 0.9129,
    'services': {
      'collect': false,
      'treatment': true
    },
    'wastes': [
      'Biodéchets',
      'Papier',
      'Biodéchets'
    ],
    'email': 'shaunadean@portica.com'
  },
  {
    '_id': '5a6750d72500c6f5f5eefee8',
    'name': 'EXOBLUE',
    'postcode': 26979,
    'phone': '+33 (970) 571-3810',
    'address': '439 Union Avenue',
    'lat': 49.9224,
    'lng': -0.6584,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Biodéchets',
      'Carton',
      'Papier'
    ],
    'email': 'shaunadean@exoblue.com'
  },
  {
    '_id': '5a6750d78457592dd2464318',
    'name': 'ZENTIX',
    'postcode': 25776,
    'phone': '+33 (850) 464-2269',
    'address': '884 Mill Avenue',
    'lat': 47.1397,
    'lng': 2.2815,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Papier',
      'Biodéchets',
      'Biodéchets'
    ],
    'email': 'shaunadean@zentix.com'
  },
  {
    '_id': '5a6750d7263f6cde2d93480c',
    'name': 'JAMNATION',
    'postcode': 10329,
    'phone': '+33 (820) 502-2131',
    'address': '853 Garden Street',
    'lat': 49.5566,
    'lng': 1.0815,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Biodéchets',
      'Biodéchets',
      'Carton'
    ],
    'email': 'shaunadean@jamnation.com'
  },
  {
    '_id': '5a6750d7ac2bd34250d6e683',
    'name': 'OPTIQUE',
    'postcode': 81504,
    'phone': '+33 (860) 459-2837',
    'address': '905 Gelston Avenue',
    'lat': 48.8287,
    'lng': -1.1,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Biodéchets',
      'Papier',
      'Carton'
    ],
    'email': 'shaunadean@optique.com'
  },
  {
    '_id': '5a6750d73e4b4711777c175e',
    'name': 'SNOWPOKE',
    'postcode': 31137,
    'phone': '+33 (956) 408-3969',
    'address': '689 Creamer Street',
    'lat': 48.231,
    'lng': 0.4834,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Papier',
      'Biodéchets',
      'Papier'
    ],
    'email': 'shaunadean@snowpoke.com'
  },
  {
    '_id': '5a6750d7cdcd363e096a0364',
    'name': 'RAMJOB',
    'postcode': 28702,
    'phone': '+33 (879) 588-2751',
    'address': '403 Calder Place',
    'lat': 46.5447,
    'lng': 1.2355,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Papier',
      'Papier',
      'Carton'
    ],
    'email': 'shaunadean@ramjob.com'
  },
  {
    '_id': '5a6750d75d23c17b4b5694c3',
    'name': 'DUOFLEX',
    'postcode': 26875,
    'phone': '+33 (918) 416-3511',
    'address': '509 Ralph Avenue',
    'lat': 49.56,
    'lng': -0.4278,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Biodéchets',
      'Biodéchets',
      'Biodéchets'
    ],
    'email': 'shaunadean@duoflex.com'
  },
  {
    '_id': '5a6750d756ebfa24d3d1af68',
    'name': 'SOFTMICRO',
    'postcode': 24912,
    'phone': '+33 (894) 528-3491',
    'address': '844 Monitor Street',
    'lat': 48.2714,
    'lng': 1.1824,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Biodéchets',
      'Biodéchets',
      'Papier'
    ],
    'email': 'shaunadean@softmicro.com'
  },
  {
    '_id': '5a6750d73c5aa2dc9ed6ee9e',
    'name': 'CINCYR',
    'postcode': 72860,
    'phone': '+33 (869) 590-3575',
    'address': '623 Bayview Place',
    'lat': 45.3075,
    'lng': 0.8612,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Biodéchets',
      'Biodéchets',
      'Biodéchets'
    ],
    'email': 'shaunadean@cincyr.com'
  },
  {
    '_id': '5a6750d7947eeb481e407ab4',
    'name': 'KRAG',
    'postcode': 52835,
    'phone': '+33 (901) 472-2361',
    'address': '490 Holmes Lane',
    'lat': 48.7748,
    'lng': 1.0814,
    'services': {
      'collect': false,
      'treatment': true
    },
    'wastes': [
      'Papier',
      'Biodéchets',
      'Biodéchets'
    ],
    'email': 'shaunadean@krag.com'
  },
  {
    '_id': '5a6750d73429a9452c603d9b',
    'name': 'INJOY',
    'postcode': 52681,
    'phone': '+33 (808) 509-2158',
    'address': '436 Montana Place',
    'lat': 46.1449,
    'lng': 0.6756,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Papier',
      'Papier',
      'Papier'
    ],
    'email': 'shaunadean@injoy.com'
  },
  {
    '_id': '5a6750d7845b626b428f23f6',
    'name': 'ISOPLEX',
    'postcode': 88268,
    'phone': '+33 (925) 600-2026',
    'address': '134 Guider Avenue',
    'lat': 48.1075,
    'lng': -1.983,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Biodéchets',
      'Biodéchets'
    ],
    'email': 'shaunadean@isoplex.com'
  },
  {
    '_id': '5a6750d78ab0a2f0c1fb69a6',
    'name': 'ZILODYNE',
    'postcode': 38020,
    'phone': '+33 (877) 566-3454',
    'address': '832 Cornelia Street',
    'lat': 45.7427,
    'lng': 2.3349,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Biodéchets',
      'Carton'
    ],
    'email': 'shaunadean@zilodyne.com'
  },
  {
    '_id': '5a6750d7d5c436a1ebf0b990',
    'name': 'GREEKER',
    'postcode': 67029,
    'phone': '+33 (991) 400-3485',
    'address': '374 Dooley Street',
    'lat': 47.1129,
    'lng': 3.3033,
    'services': {
      'collect': false,
      'treatment': true
    },
    'wastes': [
      'Papier',
      'Papier',
      'Papier'
    ],
    'email': 'shaunadean@greeker.com'
  },
  {
    '_id': '5a6750d7b0d4bb64fa0e78b3',
    'name': 'COMBOT',
    'postcode': 16726,
    'phone': '+33 (810) 532-2291',
    'address': '686 Anna Court',
    'lat': 48.7949,
    'lng': -0.1259,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Papier',
      'Carton',
      'Biodéchets'
    ],
    'email': 'shaunadean@combot.com'
  },
  {
    '_id': '5a6750d7d4b389854495d12f',
    'name': 'ASSURITY',
    'postcode': 18322,
    'phone': '+33 (916) 415-2793',
    'address': '464 Ash Street',
    'lat': 46.4795,
    'lng': 2.372,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Papier',
      'Carton',
      'Carton'
    ],
    'email': 'shaunadean@assurity.com'
  },
  {
    '_id': '5a6750d75625c4398c46d1ef',
    'name': 'VERBUS',
    'postcode': 71906,
    'phone': '+33 (935) 441-3200',
    'address': '946 Vermont Court',
    'lat': 45.6068,
    'lng': -0.2554,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Biodéchets',
      'Biodéchets',
      'Carton'
    ],
    'email': 'shaunadean@verbus.com'
  },
  {
    '_id': '5a6750d7abf679805089c163',
    'name': 'OULU',
    'postcode': 70777,
    'phone': '+33 (839) 490-2334',
    'address': '587 Waldorf Court',
    'lat': 49.557,
    'lng': 0.921,
    'services': {
      'collect': false,
      'treatment': true
    },
    'wastes': [
      'Biodéchets',
      'Papier',
      'Carton'
    ],
    'email': 'shaunadean@oulu.com'
  },
  {
    '_id': '5a6750d7692973ba8171ffb7',
    'name': 'GENESYNK',
    'postcode': 24924,
    'phone': '+33 (867) 508-3969',
    'address': '183 Martense Street',
    'lat': 49.4314,
    'lng': 1.0359,
    'services': {
      'collect': false,
      'treatment': true
    },
    'wastes': [
      'Carton',
      'Papier',
      'Papier'
    ],
    'email': 'shaunadean@genesynk.com'
  },
  {
    '_id': '5a6750d7b9df30bc9809e1c2',
    'name': 'EXIAND',
    'postcode': 71009,
    'phone': '+33 (854) 446-3273',
    'address': '725 Ditmars Street',
    'lat': 46.8327,
    'lng': 2.1771,
    'services': {
      'collect': false,
      'treatment': true
    },
    'wastes': [
      'Papier',
      'Papier',
      'Papier'
    ],
    'email': 'shaunadean@exiand.com'
  },
  {
    '_id': '5a6750d76692f1f9ff860db9',
    'name': 'CYTREX',
    'postcode': 68916,
    'phone': '+33 (817) 595-3115',
    'address': '225 Roebling Street',
    'lat': 45.6678,
    'lng': 3.8841,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Biodéchets',
      'Papier'
    ],
    'email': 'shaunadean@cytrex.com'
  },
  {
    '_id': '5a6750d7e698d1539826c5b6',
    'name': 'ROCKLOGIC',
    'postcode': 24333,
    'phone': '+33 (831) 413-2304',
    'address': '945 Ovington Court',
    'lat': 47.292,
    'lng': -0.7038,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Papier',
      'Papier',
      'Carton'
    ],
    'email': 'shaunadean@rocklogic.com'
  },
  {
    '_id': '5a6750d783dd5127d0477410',
    'name': 'COGENTRY',
    'postcode': 10875,
    'phone': '+33 (936) 449-2795',
    'address': '715 Doone Court',
    'lat': 49.9673,
    'lng': 3.3303,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Biodéchets',
      'Carton',
      'Biodéchets'
    ],
    'email': 'shaunadean@cogentry.com'
  },
  {
    '_id': '5a6750d7d9869d646afa5e25',
    'name': 'NITRACYR',
    'postcode': 11038,
    'phone': '+33 (944) 587-3370',
    'address': '954 Schroeders Avenue',
    'lat': 46.3621,
    'lng': -0.3621,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Biodéchets',
      'Carton'
    ],
    'email': 'shaunadean@nitracyr.com'
  },
  {
    '_id': '5a6750d7638b1e95ccdb21cf',
    'name': 'FANFARE',
    'postcode': 79016,
    'phone': '+33 (964) 555-3361',
    'address': '341 Stewart Street',
    'lat': 48.3519,
    'lng': 2.448,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Papier',
      'Carton',
      'Carton'
    ],
    'email': 'shaunadean@fanfare.com'
  },
  {
    '_id': '5a6750d7775ebab1e6582df9',
    'name': 'BILLMED',
    'postcode': 59769,
    'phone': '+33 (877) 553-3107',
    'address': '138 Wythe Place',
    'lat': 46.7884,
    'lng': -0.1865,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Carton',
      'Papier',
      'Biodéchets'
    ],
    'email': 'shaunadean@billmed.com'
  },
  {
    '_id': '5a6750d7e5196d2bd3b3382a',
    'name': 'OMATOM',
    'postcode': 34005,
    'phone': '+33 (906) 493-2822',
    'address': '108 Lawton Street',
    'lat': 49.0228,
    'lng': 3.5479,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Carton',
      'Papier',
      'Biodéchets'
    ],
    'email': 'shaunadean@omatom.com'
  },
  {
    '_id': '5a6750d77b767acb397db5e7',
    'name': 'SYBIXTEX',
    'postcode': 43847,
    'phone': '+33 (873) 537-2759',
    'address': '678 Bleecker Street',
    'lat': 49.3474,
    'lng': 1.346,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Carton',
      'Carton'
    ],
    'email': 'shaunadean@sybixtex.com'
  },
  {
    '_id': '5a6750d7073c847bb39142d5',
    'name': 'OVOLO',
    'postcode': 33470,
    'phone': '+33 (943) 458-2605',
    'address': '212 Broome Street',
    'lat': 45.1877,
    'lng': 3.1321,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Papier',
      'Carton'
    ],
    'email': 'shaunadean@ovolo.com'
  },
  {
    '_id': '5a6750d75ba554c146c9370c',
    'name': 'CYCLONICA',
    'postcode': 39867,
    'phone': '+33 (878) 450-2952',
    'address': '541 Judge Street',
    'lat': 46.4725,
    'lng': 3.6136,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Biodéchets',
      'Biodéchets',
      'Papier'
    ],
    'email': 'shaunadean@cyclonica.com'
  },
  {
    '_id': '5a6750d7e2e919d173eb44d4',
    'name': 'FROSNEX',
    'postcode': 72861,
    'phone': '+33 (813) 511-3768',
    'address': '718 Franklin Street',
    'lat': 49.1166,
    'lng': 0.5923,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Biodéchets',
      'Papier',
      'Papier'
    ],
    'email': 'shaunadean@frosnex.com'
  },
  {
    '_id': '5a6750d71294162dad94720a',
    'name': 'REALMO',
    'postcode': 13643,
    'phone': '+33 (986) 503-3283',
    'address': '123 Heath Place',
    'lat': 49.0029,
    'lng': 2.7677,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Biodéchets',
      'Carton',
      'Biodéchets'
    ],
    'email': 'shaunadean@realmo.com'
  },
  {
    '_id': '5a6750d76cadb69f98c65e48',
    'name': 'EXODOC',
    'postcode': 63508,
    'phone': '+33 (833) 491-3295',
    'address': '631 Herkimer Street',
    'lat': 45.6136,
    'lng': -1.515,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Carton',
      'Papier'
    ],
    'email': 'shaunadean@exodoc.com'
  },
  {
    '_id': '5a6750d736ac4876e716f941',
    'name': 'UNIA',
    'postcode': 30571,
    'phone': '+33 (892) 485-3067',
    'address': '666 Herkimer Court',
    'lat': 49.4664,
    'lng': 3.3452,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Carton',
      'Papier',
      'Carton'
    ],
    'email': 'shaunadean@unia.com'
  },
  {
    '_id': '5a6750d77bfb1a86aef7204f',
    'name': 'ECRATIC',
    'postcode': 43046,
    'phone': '+33 (997) 588-3365',
    'address': '609 Conover Street',
    'lat': 48.0712,
    'lng': 3.1024,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Papier',
      'Papier',
      'Carton'
    ],
    'email': 'shaunadean@ecratic.com'
  },
  {
    '_id': '5a6750d7da7e9d8a48df4e49',
    'name': 'FIREWAX',
    'postcode': 10029,
    'phone': '+33 (822) 464-3953',
    'address': '374 Amboy Street',
    'lat': 48.0144,
    'lng': 2.951,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Biodéchets',
      'Biodéchets',
      'Carton'
    ],
    'email': 'shaunadean@firewax.com'
  },
  {
    '_id': '5a6750d7b06fca781e832f75',
    'name': 'KOG',
    'postcode': 13420,
    'phone': '+33 (918) 522-2416',
    'address': '142 Rockaway Parkway',
    'lat': 45.5791,
    'lng': -0.2795,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Papier',
      'Carton'
    ],
    'email': 'shaunadean@kog.com'
  },
  {
    '_id': '5a6750d7728d52aa65b3fee9',
    'name': 'GEEKNET',
    'postcode': 48828,
    'phone': '+33 (938) 477-3303',
    'address': '121 Louisiana Avenue',
    'lat': 46.6974,
    'lng': 2.8965,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Carton',
      'Biodéchets',
      'Papier'
    ],
    'email': 'shaunadean@geeknet.com'
  },
  {
    '_id': '5a6750d7b00f0a3366dafbad',
    'name': 'ZIPAK',
    'postcode': 10444,
    'phone': '+33 (905) 461-2127',
    'address': '560 Greenwood Avenue',
    'lat': 46.4892,
    'lng': -1.9056,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Biodéchets',
      'Carton',
      'Papier'
    ],
    'email': 'shaunadean@zipak.com'
  },
  {
    '_id': '5a6750d76b5bf4e3e635d2f3',
    'name': 'BEADZZA',
    'postcode': 30147,
    'phone': '+33 (960) 483-3627',
    'address': '948 Coventry Road',
    'lat': 47.9646,
    'lng': 3.2976,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Papier',
      'Carton',
      'Papier'
    ],
    'email': 'shaunadean@beadzza.com'
  },
  {
    '_id': '5a6750d75a4f690a6754fc95',
    'name': 'NAVIR',
    'postcode': 23839,
    'phone': '+33 (875) 539-3404',
    'address': '792 Stuyvesant Avenue',
    'lat': 49.4349,
    'lng': 2.197,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Papier',
      'Carton',
      'Carton'
    ],
    'email': 'shaunadean@navir.com'
  },
  {
    '_id': '5a6750d7d307fde262cfbc1e',
    'name': 'BOINK',
    'postcode': 81180,
    'phone': '+33 (892) 509-2753',
    'address': '639 Stryker Court',
    'lat': 47.3969,
    'lng': 0.0429,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Biodéchets',
      'Papier',
      'Papier'
    ],
    'email': 'shaunadean@boink.com'
  },
  {
    '_id': '5a6750d74bbdfeadf817bac7',
    'name': 'ESSENSIA',
    'postcode': 22715,
    'phone': '+33 (925) 509-3624',
    'address': '365 Rockwell Place',
    'lat': 47.5996,
    'lng': 0.5286,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Biodéchets',
      'Carton'
    ],
    'email': 'shaunadean@essensia.com'
  },
  {
    '_id': '5a6750d7c124ed6c53405ba4',
    'name': 'MITROC',
    'postcode': 46737,
    'phone': '+33 (870) 428-2013',
    'address': '352 Hoyts Lane',
    'lat': 47.5349,
    'lng': -1.3882,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Papier',
      'Papier'
    ],
    'email': 'shaunadean@mitroc.com'
  },
  {
    '_id': '5a6750d7cd7249f6b4dc9a25',
    'name': 'FUTURIZE',
    'postcode': 48308,
    'phone': '+33 (952) 505-2131',
    'address': '162 Ainslie Street',
    'lat': 47.1559,
    'lng': -1.7674,
    'services': {
      'collect': false,
      'treatment': true
    },
    'wastes': [
      'Carton',
      'Carton',
      'Papier'
    ],
    'email': 'shaunadean@futurize.com'
  },
  {
    '_id': '5a6750d7cbc2e4ab5348d3ad',
    'name': 'XIIX',
    'postcode': 75394,
    'phone': '+33 (986) 497-2578',
    'address': '489 Portal Street',
    'lat': 48.7084,
    'lng': 0.8181,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Papier',
      'Carton'
    ],
    'email': 'shaunadean@xiix.com'
  },
  {
    '_id': '5a6750d7733f7bb7fc522855',
    'name': 'UNQ',
    'postcode': 56795,
    'phone': '+33 (974) 559-3756',
    'address': '704 Dunham Place',
    'lat': 45.2145,
    'lng': 2.0765,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Papier',
      'Biodéchets',
      'Biodéchets'
    ],
    'email': 'shaunadean@unq.com'
  },
  {
    '_id': '5a6750d74e8adc1cff6451c5',
    'name': 'MANTRO',
    'postcode': 56779,
    'phone': '+33 (838) 596-2057',
    'address': '194 Prospect Avenue',
    'lat': 48.8736,
    'lng': -0.4074,
    'services': {
      'collect': false,
      'treatment': true
    },
    'wastes': [
      'Biodéchets',
      'Papier',
      'Carton'
    ],
    'email': 'shaunadean@mantro.com'
  },
  {
    '_id': '5a6750d72de06f550e053fb7',
    'name': 'FANGOLD',
    'postcode': 11382,
    'phone': '+33 (820) 457-3246',
    'address': '278 Crosby Avenue',
    'lat': 49.5931,
    'lng': -0.5132,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Carton',
      'Biodéchets'
    ],
    'email': 'shaunadean@fangold.com'
  },
  {
    '_id': '5a6750d712d2f2a569c55daf',
    'name': 'GENMOM',
    'postcode': 60519,
    'phone': '+33 (812) 408-3013',
    'address': '564 Wallabout Street',
    'lat': 45.9173,
    'lng': 0.6667,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Papier',
      'Papier',
      'Carton'
    ],
    'email': 'shaunadean@genmom.com'
  },
  {
    '_id': '5a6750d7f613774e481fb00a',
    'name': 'BUZZNESS',
    'postcode': 80479,
    'phone': '+33 (880) 548-3749',
    'address': '587 Aster Court',
    'lat': 49.8322,
    'lng': 3.3208,
    'services': {
      'collect': true,
      'treatment': true
    },
    'wastes': [
      'Carton',
      'Papier',
      'Carton'
    ],
    'email': 'shaunadean@buzzness.com'
  },
  {
    '_id': '5a6750d73311e94e63b7a043',
    'name': 'ENTALITY',
    'postcode': 54644,
    'phone': '+33 (974) 579-3949',
    'address': '930 Royce Place',
    'lat': 45.9089,
    'lng': 0.231,
    'services': {
      'collect': false,
      'treatment': true
    },
    'wastes': [
      'Papier',
      'Biodéchets',
      'Papier'
    ],
    'email': 'shaunadean@entality.com'
  },
  {
    '_id': '5a6750d784dddc9bceff789e',
    'name': 'ISOSURE',
    'postcode': 78442,
    'phone': '+33 (958) 468-3355',
    'address': '581 Nostrand Avenue',
    'lat': 46.6691,
    'lng': 3.255,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Biodéchets',
      'Biodéchets',
      'Carton'
    ],
    'email': 'shaunadean@isosure.com'
  },
  {
    '_id': '5a6750d7b593ad9625d7e426',
    'name': 'DANCITY',
    'postcode': 80470,
    'phone': '+33 (999) 414-3686',
    'address': '360 Kossuth Place',
    'lat': 48.2457,
    'lng': -1.398,
    'services': {
      'collect': false,
      'treatment': true
    },
    'wastes': [
      'Carton',
      'Papier',
      'Papier'
    ],
    'email': 'shaunadean@dancity.com'
  },
  {
    '_id': '5a6750d735a6b88dcea9358f',
    'name': 'COMTREK',
    'postcode': 62112,
    'phone': '+33 (925) 422-2193',
    'address': '648 Malta Street',
    'lat': 45.0323,
    'lng': 2.8774,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Biodéchets',
      'Papier'
    ],
    'email': 'shaunadean@comtrek.com'
  },
  {
    '_id': '5a6750d79b9ec95afd619d49',
    'name': 'PYRAMIA',
    'postcode': 26709,
    'phone': '+33 (823) 428-3389',
    'address': '510 Colin Place',
    'lat': 45.7473,
    'lng': -0.3684,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Biodéchets',
      'Biodéchets',
      'Carton'
    ],
    'email': 'shaunadean@pyramia.com'
  },
  {
    '_id': '5a6750d72dbacf730da1c110',
    'name': 'TOURMANIA',
    'postcode': 23212,
    'phone': '+33 (986) 559-2516',
    'address': '796 Elliott Place',
    'lat': 48.8509,
    'lng': -1.467,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Carton',
      'Carton',
      'Papier'
    ],
    'email': 'shaunadean@tourmania.com'
  },
  {
    '_id': '5a6750d797d9a943eb42bbcc',
    'name': 'MEDESIGN',
    'postcode': 23943,
    'phone': '+33 (909) 513-2333',
    'address': '917 Anthony Street',
    'lat': 46.1393,
    'lng': -0.8009,
    'services': {
      'collect': false,
      'treatment': false
    },
    'wastes': [
      'Biodéchets',
      'Biodéchets',
      'Carton'
    ],
    'email': 'shaunadean@medesign.com'
  },
  {
    '_id': '5a6750d707c32d3fd9822b89',
    'name': 'ORBIN',
    'postcode': 60458,
    'phone': '+33 (849) 546-3603',
    'address': '578 Gerritsen Avenue',
    'lat': 47.7289,
    'lng': 1.2461,
    'services': {
      'collect': false,
      'treatment': true
    },
    'wastes': [
      'Papier',
      'Carton',
      'Biodéchets'
    ],
    'email': 'shaunadean@orbin.com'
  },
  {
    '_id': '5a6750d784a685dcd0ffad07',
    'name': 'ULTRIMAX',
    'postcode': 53553,
    'phone': '+33 (974) 416-3528',
    'address': '441 Banner Avenue',
    'lat': 47.6323,
    'lng': 3.8613,
    'services': {
      'collect': true,
      'treatment': false
    },
    'wastes': [
      'Papier',
      'Papier',
      'Biodéchets'
    ],
    'email': 'shaunadean@ultrimax.com'
  }
]};



// WEBPACK FOOTER //
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/seeds/seeds.ts